module.exports = __webpack_public_path__ + "a17d279f/img/dollar-icon.35c9d638.svg";